import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

interface ContainerProps {
  type?: 'success' | 'error' | 'info' | 'warning';
  hasdescription: boolean;
}

const toastTypeVariations = {
  info: css`
    border: 2px solid #262626;
    background: #e6e6e6;
    color: #262626;
  `,
  success: css`
    border: 2px solid #009900;
    background: #e6e6e6;
    color: #009900;
  `,
  error: css`
    border: 2px solid #bc4143;
    background: #e6e6e6;
    color: #bc4143;
  `,
  warning: css`
    border: 2px solid #c46008;
    background: #f57f17;
    color: #262626;
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  z-index: 61;
  width: 350px;

  position: relative;
  padding: 16px 30px 16px 16px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

  display: flex;

  & + div {
    margin-top: 10px;
  }

  ${(props) => toastTypeVariations[props.type || 'info']}

  > svg {
    margin: 4px 12px 0 0;
  }

  div {
    flex: 1;

    strong {
      font-size: 16px;
    }
    p {
      margin-top: 4px;
      font-size: 14px;
      opacity: 0.8;
      line-height: 20px;
    }
  }

  button {
    position: absolute;
    right: 16px;
    top: 19px;
    opacity: 0.7;
    border: 0;
    outline: none;
    background: transparent;
    color: inherit;
  }

  ${(props) =>
    !props.hasdescription &&
    css`
      align-items: center;
      svg {
        margin-top: 0;
      }
    `}
`;
